module.exports = __webpack_public_path__ + "static/media/key.59bf2cc3.png";